export type HotItem = {
  id: number;
  rank: number;
  title: string;
  category: string;
  heat: string;
  badge: string;
  summary: string;
};

export const hotCategories = [
  '全部',
  '综艺现场',
  '影视剧组',
  '选秀内幕',
  '直播翻车',
  '商务代言',
];

export const hotChart: HotItem[] = [
  {
    id: 1,
    rank: 1,
    title: '顶流综艺录制现场「变脸名场面」完整时间线',
    category: '综艺现场',
    heat: '128.6w',
    badge: '燃',
    summary: '从入座到收工，前后不到四十分钟的三次情绪转折，被现场观众按顺序串成了一条完整线。',
  },
  {
    id: 2,
    rank: 2,
    title: '选秀成团夜后台流出的「分part草案」',
    category: '选秀内幕',
    heat: '96.3w',
    badge: '高能',
    summary: '一份标注了时间戳的曲目分配表，解释了为什么某位选手的镜头与前排座位始终错开。',
  },
  {
    id: 3,
    rank: 3,
    title: '某剧组建组三个月即解散，真实原因被还原',
    category: '影视剧组',
    heat: '84.1w',
    badge: '精华',
    summary: '通告单、场记本与酒店退房时间三份材料互相对照，还原了停机前后的完整经过。',
  },
  {
    id: 4,
    rank: 4,
    title: '直播间「口误」事件前后的弹幕切片合集',
    category: '直播翻车',
    heat: '77.9w',
    badge: '高能',
    summary: '按秒切分的弹幕记录，把当晚那句被反复搬运的话放回了它原本的语境里。',
  },
  {
    id: 5,
    rank: 5,
    title: '商务代言临阵换人：品牌方的三版物料对比',
    category: '商务代言',
    heat: '63.4w',
    badge: '精华',
    summary: '同一组拍摄花絮的三个版本，从构图到衣服配色，能看出文案被改了几轮。',
  },
  {
    id: 6,
    rank: 6,
    title: '音乐节压轴换序：一份被撤回的演出流程表',
    category: '综艺现场',
    heat: '58.2w',
    badge: '燃',
    summary: '两份流程表的顺序差异，正好对上了当晚后台那条被删掉的动态。',
  },
  {
    id: 7,
    rank: 7,
    title: '试镜厅编号之谜：为什么第七号始终没出现',
    category: '选秀内幕',
    heat: '49.7w',
    badge: '精华',
    summary: '现场贴纸、签到册与候场照片交叉比对，编号断档的位置被精确指出。',
  },
  {
    id: 8,
    rank: 8,
    title: '同框冷场三十秒：一场发布会座位表的玄机',
    category: '商务代言',
    heat: '43.5w',
    badge: '高能',
    summary: '座位表被改过两次，最终版本里原本相邻的两个名字被人为隔开了一整排。',
  },
];

export type MustReadItem = {
  id: number;
  size: 'large' | 'small';
  title: string;
  summary: string;
  tag: string;
  readTime: string;
  source: string;
  image: string;
};

export const mustRead: MustReadItem[] = [
  {
    id: 1,
    size: 'large',
    title: '一条时间线看懂「录制现场变脸」到底发生了什么',
    summary:
      '把当天流出的现场照片、观众侧录音频与后援会行程三份材料按时间排列，你会发现三个转折点其实都指向同一个细节。这是本周被引用最多的一条，也是进入黑料大全必看清单的第一站。',
    tag: '时间线',
    readTime: '6 分钟读完',
    source: '现场材料组',
    image:
      'https://readdy.ai/api/search-image?query=Backstage%20of%20a%20TV%20studio%20with%20warm%20amber%20lighting%2C%20empty%20director%20chairs%20and%20spotlights%2C%20moody%20cinematic%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20soft%20negative%20space&width=900&height=620&seq=heitao-mr-01&orientation=landscape',
  },
  {
    id: 2,
    size: 'small',
    title: '「分part草案」逐条读：谁被安排在了镜头死角',
    summary: '对照舞台走位图，把草案里的时间戳还原成站位，答案比想象中直白。',
    tag: '选秀内幕',
    readTime: '4 分钟',
    source: '资料归档',
    image:
      'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20vintage%20film%20camera%20on%20a%20movie%20set%20with%20warm%20golden%20light%2C%20cinematic%20shallow%20depth%20of%20field%2C%20muted%20warm%20background&width=600&height=420&seq=heitao-mr-02&orientation=landscape',
  },
  {
    id: 3,
    size: 'small',
    title: '试镜厅编号断档，现场贴纸给出了另一种解释',
    summary: '签到册缺的那一页，恰好和候场照片里的空椅子对得上。',
    tag: '现场还原',
    readTime: '3 分钟',
    source: '候场记录',
    image:
      'https://readdy.ai/api/search-image?query=Empty%20audition%20stage%20with%20numbered%20floor%20marks%20and%20warm%20amber%20stage%20light%2C%20atmospheric%20editorial%20photography%2C%20quiet%20mood&width=600&height=420&seq=heitao-mr-03&orientation=landscape',
  },
  {
    id: 4,
    size: 'small',
    title: '直播口误前三十秒，弹幕其实已经给出了预警',
    summary: '按秒回放弹幕密度曲线，那句口误并不是毫无征兆。',
    tag: '直播切片',
    readTime: '5 分钟',
    source: '弹幕回放组',
    image:
      'https://readdy.ai/api/search-image?query=Ring%20light%20and%20microphone%20in%20a%20dark%20livestream%20room%20with%20warm%20orange%20glow%2C%20cinematic%20moody%20still%20life%2C%20soft%20contrast&width=600&height=420&seq=heitao-mr-04&orientation=landscape',
  },
  {
    id: 5,
    size: 'small',
    title: '代言换人前后，品牌物料改了三版的地方在这',
    summary: '把三份花絮叠在一起看，被替换的从来不只是人。',
    tag: '商务观察',
    readTime: '4 分钟',
    source: '物料对比',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20glossy%20magazines%20and%20printed%20contract%20papers%20on%20a%20warm%20wooden%20desk%2C%20editorial%20flat%20lay%20with%20amber%20tones%2C%20clean%20composition&width=600&height=420&seq=heitao-mr-05&orientation=landscape',
  },
];

export type RoundupItem = {
  id: number;
  no: string;
  title: string;
  desc: string;
  count: string;
  image: string;
};

export const roundup: RoundupItem[] = [
  {
    id: 1,
    no: '01',
    title: '被删掉的十条动态：截图比原文更完整',
    desc: '按发布时间排序，把每条动态的编辑记录与评论区截图放在一起，还原每次改动的方向。',
    count: '10 条收录',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20warm%20amber%20abstract%20geometric%20shape%20on%20cream%20background%2C%20editorial%20studio%20still%20life%2C%20soft%20grain&width=400&height=400&seq=heitao-ru-01&orientation=squarish',
  },
  {
    id: 2,
    no: '02',
    title: '换角风波全记录：从官宣到重拍的十四天',
    desc: '把那两周的通告、路透与官方声明按天排列，你会发现关键节点其实只有三个。',
    count: '14 天归档',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20terracotta%20abstract%20circle%20and%20line%20composition%20on%20light%20warm%20background%2C%20editorial%20studio%20still%20life&width=400&height=400&seq=heitao-ru-02&orientation=squarish',
  },
  {
    id: 3,
    no: '03',
    title: '番位之争六问六答：这次终于有人把顺序讲清了',
    desc: '从署名规则到海报字体大小，用最直白的方式回答六个被反复追问的问题。',
    count: '6 组问答',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20clay%20beige%20abstract%20stacked%20paper%20forms%20on%20warm%20background%2C%20editorial%20studio%20still%20life%2C%20subtle%20amber%20light&width=400&height=400&seq=heitao-ru-03&orientation=squarish',
  },
];

export type CollectionItem = {
  id: number;
  title: string;
  desc: string;
  items: number;
  heat: string;
  image: string;
};

export const collections: CollectionItem[] = [
  {
    id: 1,
    title: '高能盘点 · 名场面合集',
    desc: '按高能程度排序的现场切片，一条一个名场面。',
    items: 42,
    heat: '爆款',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20burgundy%20and%20amber%20textured%20background%20with%20soft%20light%20streaks%2C%20editorial%20minimal%20composition%2C%20grain%20texture&width=700&height=500&seq=heitao-col-01&orientation=landscape',
  },
  {
    id: 2,
    title: '必看清单 · 时间线合辑',
    desc: '把复杂事件拆成时间线，读一遍就懂来龙去脉。',
    items: 28,
    heat: '热推',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20deep%20terracotta%20gradient%20backdrop%20with%20grain%20texture%20and%20warm%20rim%20light%2C%20editorial%20minimal%20composition&width=700&height=500&seq=heitao-col-02&orientation=landscape',
  },
  {
    id: 3,
    title: '爆款合集 · 争议瞬间',
    desc: '按讨论量排序，最近三天被转最多的一批。',
    items: 35,
    heat: '飙升',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20golden%20amber%20smoke%20swirls%20on%20dark%20warm%20background%2C%20editorial%20minimal%20composition%2C%20fine%20grain&width=700&height=500&seq=heitao-col-03&orientation=landscape',
  },
  {
    id: 4,
    title: '精华推荐 · 冷门但耐看',
    desc: '热度不高，但材料扎实、值得慢慢读的一批。',
    items: 21,
    heat: '精华',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20clay%20beige%20paper%20texture%20with%20faint%20amber%20light%20gradient%2C%20editorial%20minimal%20composition&width=700&height=500&seq=heitao-col-04&orientation=landscape',
  },
];

export type IndexRow = {
  id: number;
  name: string;
  desc: string;
  count: number;
  updated: string;
  highlight?: boolean;
};

export const collectionIndex: IndexRow[] = [
  {
    id: 1,
    name: '热门榜',
    desc: '按实时讨论量滚动更新的主榜，进站先看这一栏，效率最高。',
    count: 168,
    updated: '10 分钟前',
    highlight: true,
  },
  {
    id: 2,
    name: 'TOP榜',
    desc: '周度高分条目精选，只保留材料完整、可回溯的那部分。',
    count: 50,
    updated: '1 小时前',
  },
  {
    id: 3,
    name: '必看清单',
    desc: '新手友好的入门路径，按难度从浅到深排列。',
    count: 64,
    updated: '3 小时前',
  },
  {
    id: 4,
    name: '高能盘点',
    desc: '编号式盘点合集，一条一个主题，适合一次看完。',
    count: 37,
    updated: '今天 09:20',
  },
  {
    id: 5,
    name: '爆款合集',
    desc: '按热度排序的合集墙，快速刷完最近被讨论最多的一批。',
    count: 92,
    updated: '今天 08:05',
  },
  {
    id: 6,
    name: '精华推荐',
    desc: '编辑手工整理的低热度优质内容，慢节奏阅读。',
    count: 45,
    updated: '昨天',
  },
];

export type FaqItem = {
  id: number;
  q: string;
  a: string;
};

export const faqs: FaqItem[] = [
  {
    id: 1,
    q: '黑料大全的热门榜是怎么排序的？',
    a: '热门榜主要参考条目在站内的浏览与收藏表现，并结合合集收录次数综合排序，每隔一段时间滚动更新一次，所以同一时间打开看到的顺序可能略有差异。',
  },
  {
    id: 2,
    q: '不知道先看哪个，应该从哪一栏进入？',
    a: '如果你只想快速挑「最炸的一条」，直接从 TOP榜 入口进；如果你更想系统了解一件事的来龙去脉，建议先读必看清单里的时间线条目。',
  },
  {
    id: 3,
    q: '爆款合集和高能盘点有什么区别？',
    a: '爆款合集是按热度排列的合集墙，侧重「最近被讨论最多的」；高能盘点则是编号式主题合集，一条一个主题，更强调结构和完整性。',
  },
  {
    id: 4,
    q: '精华推荐里的条目为什么热度不高？',
    a: '精华推荐由编辑手工挑选，优先看材料是否扎实、能否回溯，而不是单纯看热度。这类条目通常需要多一点耐心，但读完的信息密度更高。',
  },
  {
    id: 5,
    q: '页面上的条目多久更新一次？',
    a: '热门榜和爆款合集更新最为频繁，精华推荐与必看清单相对稳定，方便你收藏后隔一段时间再回来接着读。',
  },
];

export const heroStats = [
  { id: 1, value: '456', label: '条目收录' },
  { id: 2, value: '38', label: '主题合集' },
  { id: 3, value: '6', label: '内容分区' },
  { id: 4, value: '每日', label: '滚动更新' },
];

export const heroTags = [
  '热门榜',
  '精华推荐',
  '必看清单',
  '高能盘点',
  '爆款合集',
  'TOP榜',
];